import React from 'react';
import ReactDOM from 'react-dom';

import SomaDS from '@soma/ds';
import { init } from '@soma/react';
import xpTheme from '@soma/ds/themes/xp';

import App from './App';

init();
SomaDS.use(xpTheme);

ReactDOM.render(
  React.createElement(App),
  document.getElementById('app'),
);
